import { Injectable } from '@angular/core';
import { Configurations } from '../../core/configurations';
import { ignoreElements } from '../../../../node_modules/rxjs/operator/ignoreElements';

/**
 * MapsService class.
 *
 * This injectable class instances the map & the markers.
 * Its methods are used by the directives and can be used by a component.
 */
@Injectable() export class MapService {

    private map: google.maps.Map;

    private markers: google.maps.Marker[] = [];
    
    /**
     * Creates a new map inside of the given HTML container.
     *
     * @param el DIV element
     * @param mapOptions MapOptions object specification
     */
    initMap(el: HTMLElement, mapOptions: any): void {
        this.map = new google.maps.Map(el, mapOptions);

        // Adds event listener resize when the window changes size.
        window.addEventListener("resize", () => { this.resize(); });
        
        /*google.maps.event.trigger(this.map,'resize');
        const latLng: google.maps.LatLng = this.map.getCenter();
        this.map.setCenter(latLng);*/
        /*google.maps.event.addDomListener(this.map, 'idle', function () {  
            google.maps.event.trigger(this.map, "resize");
        });

        google.maps.event.addDomListener(window, 'resize', function () {
            google.maps.event.trigger(this.map, "resize");
        });*/
  
    }

    setCenter(latLng: google.maps.LatLng): void {
        if (this.map != null && latLng != null) {
            // Changes the center of the map to the given LatLng.
            this.map.panTo(latLng);
        }
    }

    setZoom(zoom: number): void {
        if (this.map != null) {
            this.map.setZoom(zoom);
        }
    }
    getMarkers():google.maps.Marker[] {
        return this.markers;
    }
    /**
     * Adds a marker.
     *
     * @param latLng Marker position
     * @param title Tooltip
     * @param contentString InfoWindow' content
     */
    addMarker(latLng: google.maps.LatLng, title?: string, contentString?: string,draggable:boolean=false,
        alertingMarker?:string):google.maps.Marker {
        if (this.map != null && latLng != null) {
            let url='';
            if(alertingMarker!==null) {
                url=Configurations.appBaseServiceUrl+"/content";
                if(alertingMarker ==='OK') {
                    url+="/Marker_Partite_OK.png?v="+Configurations.currentVersionCod;
                } else if(alertingMarker ==='SCOPERTO') {
                    url+="/Marker_Partite_SCOPERTO.png?v="+Configurations.currentVersionCod;
                } else if(alertingMarker ==='SCADUTE') {
                    url+="/Marker_Partite_SCADUTE.png?v="+Configurations.currentVersionCod;
                }
            }
            // Creates the marker.
            const marker: google.maps.Marker = new google.maps.Marker({
                position: latLng,
                title: title,
                draggable: draggable,
                
            });
            if(url!=='') {
                marker.setIcon(url);
                
            }
            // Adds the marker to the map.
            marker.setMap(this.map);
            // Creates the info window if required.
            if (contentString != null) {
                // Sets the max width of the info window to the width of the map element.
                const width: number = this.map.getDiv().clientWidth;
                const infoWindow: google.maps.InfoWindow = new google.maps.InfoWindow({
                    content: contentString,
                    maxWidth: width
                });
                // Makes the info window visible.
                marker.addListener('click', () => {
                    infoWindow.open(this.map, marker);
                });
            }

            // Pushes it to the markers array.
            this.markers.push(marker);
            return marker;
        } else {
            return null;
        }
    }

    deleteMarkers(): void {
        // Removes the markers from the map.
        for (let i: number = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(null);
        }
        // Removes references to them.
        this.markers = [];
    }

    private resize(): void {
        // Saves the center.
        const latLng: google.maps.LatLng = this.map.getCenter();
        // Triggers resize event.
        google.maps.event.trigger(this.map, "resize");
        // Restores the center.
        this.map.setCenter(latLng);
    }

}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/google-map/map.service.ts